// extracted by mini-css-extract-plugin
export var blockedMessage = "_86-3";
export var blockedOverlay = "_86-1";
export var fadeIn = "_86-2";
export var hereLink = "_86-0";
export var slideUp = "_86-4";